import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/pc/en/home'
import Partners from '@/views/pc/en/Partners'
import PaymentInstore from '@/views/pc/en/PaymentInstore'
import PaymentOnline from '@/views/pc/en/PaymentOnline'
import ourApp from '@/views/pc/en/ourApp'
import services from '@/views/pc/en/services'
import aboutUs from '@/views/pc/en/aboutUs'
import apply from '@/views/pc/en/apply'
import Developers from '@/views/pc/en/Developers'
const Privacy = resolve => require(['@/views/pc/en/privacy'], resolve)


import homeCn from '@/views/pc/cn/homeCn'
import PartnersCn from '@/views/pc/cn/PartnersCn'
import PaymentInstoreCn from '@/views/pc/cn/PaymentInstoreCn'
import PaymentOnlineCn from '@/views/pc/cn/PaymentOnlineCn'
import ourAppCn from '@/views/pc/cn/ourAppCn'
import servicesCn from '@/views/pc/cn/servicesCn'
import aboutUsCn from '@/views/pc/cn/aboutUsCn'
import applyCn from '@/views/pc/cn/applyCn'
import DevelopersCn from '@/views/pc/cn/DevelopersCn'

import home_m from '@/views/mobile/en/home_m'
import about_m from '@/views/mobile/en/about_m'
import apply_m from '@/views/mobile/en/apply_m'
import ourApp_m from '@/views/mobile/en/ourApp_m'
import Partners_m from '@/views/mobile/en/Partners_m'
import PaymentInstore_m from '@/views/mobile/en/PaymentInstore_m'
import PaymentOnline_m from '@/views/mobile/en/PaymentOnline_m'
import services_m from '@/views/mobile/en/services_m'

// 手机中文

import homeCn_m from '@/views/mobile/cn/home_m'
import aboutCn_m from '@/views/mobile/cn/about_m'
import applyCn_m from '@/views/mobile/cn/apply_m'
import ourAppCn_m from '@/views/mobile/cn/ourApp_m'
import PartnersCn_m from '@/views/mobile/cn/Partners_m'
import PaymentInstoreCn_m from '@/views/mobile/cn/PaymentInstore_m'
import PaymentOnlineCn_m from '@/views/mobile/cn/PaymentOnline_m'
import servicesCn_m from '@/views/mobile/cn/services_m'



Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      beforeEnter: (to, from, next) => {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        var ismobile = flag ? 1 : 0
        let language = navigator.language
        var lang;
        let tempLang = sessionStorage.getItem('lang')
        if ((tempLang && tempLang.indexOf('en') > -1) || language.indexOf('en') > -1) {
          lang = "en"
        } else {
          lang = "cn"
        }
        if (ismobile) {
          if (lang == "cn") {
            next('/homeCn_m')
          } else {
            next('/home_m')
          }
        } else {
          if (lang == "cn") {
            next('/zh-hans')
          } else {
            next()
          }
        }
      }
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      beforeEnter: (to, from, next) => {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        var ismobile = flag ? 1 : 0
        let language = navigator.language
        var lang;
        let tempLang = sessionStorage.getItem('lang')
        if ((tempLang && tempLang.indexOf('en') > -1) || language.indexOf('en') > -1) {
          lang = "en"
        } else {
          lang = "cn"
        }
        if (ismobile) {
          if (lang == "cn") {
            next('/homeCn_m')
          } else {
            next('/home_m')
          }
        } else {
          if (lang == "cn") {
            next('/zh-hans')
          } else {
            next()
          }
        }
      }
    },
    {
      path: '/home_m',
      name: 'home_m',
      component: home_m,
    },
    {
      path: '/homeCn_m',
      name: 'homeCn_m',
      component: homeCn_m,
    },

    {
      path: '/aboutus',
      name: 'aboutUs',
      component: aboutUs,
      beforeEnter: (to, from, next) => {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        var ismobile = flag ? 1 : 0
        console.log(ismobile)
        if (ismobile) {
          next('/about_m')
        } else {
          next()
        }
      }
    },
    {
      path: '/instorepayment',
      name: 'PaymentInstore',
      component: PaymentInstore,
      beforeEnter: (to, from, next) => {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        var ismobile = flag ? 1 : 0
        console.log(ismobile)
        if (ismobile) {
          next('/PaymentInstore_m')
        } else {
          next()
        }
      }
    },
    {
      path: '/onlinepayment',
      name: 'PaymentOnline',
      component: PaymentOnline,
      beforeEnter: (to, from, next) => {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        var ismobile = flag ? 1 : 0
        console.log(ismobile)
        if (ismobile) {
          next('/PaymentOnline_m')
        } else {
          next()
        }
      }
    },
    {
      path: '/services',
      name: 'services',
      component: services,
      beforeEnter: (to, from, next) => {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        var ismobile = flag ? 1 : 0
        console.log(ismobile)
        if (ismobile) {
          next('/services_m')
        } else {
          next()
        }
      }
    },
    {
      path: '/app',
      name: 'ourApp',
      component: ourApp,
      beforeEnter: (to, from, next) => {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        var ismobile = flag ? 1 : 0
        console.log(ismobile)
        if (ismobile) {
          next('/ourApp_m')
        } else {
          next()
        }
      }
    },
    {
      path: '/partners',
      name: 'Partners',
      component: Partners,
      beforeEnter: (to, from, next) => {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        var ismobile = flag ? 1 : 0
        console.log(ismobile)
        if (ismobile) {
          next('/Partners_m')
        } else {
          next()
        }
      }
    },
    {
      path: '/contact',
      name: 'apply',
      component: apply,
      beforeEnter: (to, from, next) => {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        var ismobile = flag ? 1 : 0
        console.log(ismobile)
        if (ismobile) {
          next('/apply_m')
        } else {
          next()
        }
      }
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy,
    },


    // 中文版
    {
      path: '/zh-hans',
      name: 'homeCn',
      component: homeCn,
    },
    {
      path: '/zh-hans/aboutus',
      name: 'aboutUsCn',
      component: aboutUsCn,
    },
    {
      path: '/zh-hans/instorepayment',
      name: 'PaymentInstoreCn',
      component: PaymentInstoreCn,
    },
    {
      path: '/zh-hans/onlinepayment',
      name: 'PaymentOnlineCn',
      component: PaymentOnlineCn,
    },
    {
      path: '/zh-hans/services',
      name: 'servicesCn',
      component: servicesCn,
    },
    {
      path: '/zh-hans/app',
      name: 'ourAppCn',
      component: ourAppCn,
    },
    {
      path: '/zh-hans/partners',
      name: 'PartnersCn',
      component: PartnersCn,
    },
    {
      path: '/zh-hans/contact',
      name: 'applyCn',
      component: applyCn,
    },

    {
      path: '/about_m',
      name: 'about_m',
      component: about_m,
    },
    {
      path: '/apply_m',
      name: 'apply_m',
      component: apply_m,
    },
    {
      path: '/ourApp_m',
      name: 'ourApp_m',
      component: ourApp_m,
    },
    {
      path: '/Partners_m',
      name: 'Partners_m',
      component: Partners_m,
    },
    {
      path: '/PaymentInstore_m',
      name: 'PaymentInstore_m',
      component: PaymentInstore_m,
    },
    {
      path: '/PaymentOnline_m',
      name: 'PaymentOnline_m',
      component: PaymentOnline_m,
    },
    {
      path: '/services_m',
      name: 'services_m',
      component: services_m,
    },

    {
      path: '/aboutCn_m',
      name: 'aboutCn_m',
      component: aboutCn_m,
    },
    {
      path: '/applyCn_m',
      name: 'applyCn_m',
      component: applyCn_m,
    },
    {
      path: '/ourAppCn_m',
      name: 'ourAppCn_m',
      component: ourAppCn_m,
    },
    {
      path: '/PartnersCn_m',
      name: 'PartnersCn_m',
      component: PartnersCn_m,
    },
    {
      path: '/PaymentInstoreCn_m',
      name: 'PaymentInstoreCn_m',
      component: PaymentInstoreCn_m,
    },
    {
      path: '/PaymentOnlineCn_m',
      name: 'PaymentOnlineCn_m',
      component: PaymentOnlineCn_m,
    },
    {
      path: '/servicesCn_m',
      name: 'servicesCn_m',
      component: servicesCn_m,
    },
    {
      path: '/developers',
      name: 'Developers',
      component: Developers,
    },
    {
      path: '/zh-hans/developers',
      name: 'DevelopersCn',
      component: DevelopersCn,
    }

  ]
})


export default router
